import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const VehicleName = () => {
  return (
    <SettingsMetaData propertyName={"VehicleName"} viewPropertyName={"Vehicle Name"}/>
  );
};

export default VehicleName;
